module.exports = __webpack_public_path__ + "img/Perks-Gift-75.f5fa5e80.png";